import $ from "jquery";
import jsPDF from "jspdf";
import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import AlertModal from "../CommonControlls/AlertModal";
import * as Common from "../CommonControlls/CommonJs";
import DropDown from "../CommonControlls/DropdownRendrer";
import MainLayout from "../CommonControlls/MainLayout";
import Table from "../CommonControlls/TableRendrer";
import Topmenu from "../CommonControlls/Topmenubar";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import OthersPDF from "./Others-pdf";
import RidersPDF from "./Riders-pdf";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class Users_List extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loggedinUser: 0,

			Parameters: {},
			// Table
			data: [],
			page: 1,
			sizePerPage: 15,
			TotalRecord: 0,
			loading: false,
			exportLoading: false,

			permissions: [],

			sortField: "id",
			idsortOrder: "desc",
			provinceNamesortOrder: "",
			districtNamesortOrder: "",
			tehsilNamesortOrder: "",
			roleNamesortOrder: "",
			appVersionsortOrder: "",

			SrList: [],
			SrId: [],
			FilteredSrs: [],

			//Roles
			RolesLoader: false,
			Roleslist: [],
			RoleId: 0,

			

			alertModalData: {
				title: "",
				message: "",
				First_Callback: () => {},
				Second_Callback: () => {},
				type: 1,
			},

			ProvinceLoader: false,
			Provincelist: [],
			ProvinceId: [],

			loadingExport: false,

			DistrictLoader: false,
			Districtlist: [],
			FilteredDistrictlist: [],
			DistrictId: [],
			riderType: "",

			TehsilLoader: false,
			Tehsillist: [],
			FilteredTehsillist: [],
			TehsilId: [],

			downloadPdfOthers: false,
			downloadPdfRiders: false,
			pdfData: {},
		};
	}

	RiderTypes = [
		{ id: 'cvr', name: 'CVR' },
		{ id: 'fr', name: 'Fixed Rider' },
		{ id: 'publicServant', name: 'Public Servant' },
		{ id: "privateServant", name: "Private Servant" },
		{ id: 'projectStaff', name: 'Project Staff' },
	]

	HandleRiderTypeValChange = (fieldId, value) => {
		console.log(fieldId)
		console.log(value)
		this.setState({[fieldId]: value});
	}

	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState(
			{
				[fieldId]: value,
				// isSaveSearch: this.state.isSearchChanged ? true : false
			},
			() => {
				if (fieldId === "ProvinceId") {
					this.FilterDistricts(value);
				}
				if (fieldId === "SrId") {
					var selectedSrs = this.state.SrId;
					const tempDistricts = this.state.Districtlist;
					var filteredSrsId = Common.ConvertToCommaSplitArray(
						selectedSrs,
						"id"
					);
					var filteredSelectedDistricts = tempDistricts.filter(function (obj) {
						return filteredSrsId.indexOf(obj.subrecipientid) > -1;
					});
					this.setState({
						FilteredDistrictlist: filteredSelectedDistricts,
					});
				}
				if (fieldId === "DistrictId") {
					this.FilterTehsils(value);
				}
			}
		);
	};
	FilterDistricts = (value) => {
		// filter ditrict list
		// var TempArr = this.state.Districtlist
		// var filteredDistrictList = TempArr.filter(function (obj) {
		//     return selectedProvince.indexOf(obj.provinceId) > -1
		// });

		var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
		const tempSrs = this.state.SrList;
		const filteredSrs = tempSrs.filter(
			(item) => selectedProvince.indexOf(item.provinceid) > -1
		);

		// filter district selected values
		// var selectedDistricts = this.state.DistrictId
		// var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(filteredDistrictList, "id")
		// var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
		//     return filteredDistrictIdArr.indexOf(obj.id) > -1
		// });

		this.setState({
			// FilteredDistrictlist: filteredDistrictList,
			// DistrictId: filteredSelectedDistricts,
			FilteredSrs: filteredSrs,
		});
	};
	FilterTehsils = (value) => {
		// filter Tehsil list
		var TempArr = this.state.Tehsillist;
		var selectedVale = Common.ConvertToCommaSplitArray(value, "id");
		var filteredTehsilList = TempArr.filter(function (obj) {
			return selectedVale.indexOf(obj.districtId) > -1;
		});

		// filter Tehsil selected values
		var selectedTehsils = this.state.TehsilId;
		var filteredTehsilIdArr = Common.ConvertToCommaSplitArray(
			filteredTehsilList,
			"id"
		);
		var filteredSelectedTehsils = selectedTehsils.filter(function (obj) {
			return filteredTehsilIdArr.indexOf(obj.id) > -1;
		});

		this.setState({
			FilteredTehsillist: filteredTehsilList,
			TehsilId: filteredSelectedTehsils,
		});
	};

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}

		Common.parseJwt(this.props.UserAuthentication.AuthToken, (user) => {
			this.setState({
				loggedinUser: user.id,
			});
		});
	}

	componentDidMount() {
		Common.AddClassToMenueLink("MenuLink_Users");
		this.GetPageConfigData(() => {
			this.PopulateTable();
		});
		$(".Search_InputField").on("keypress", (e) => {
			if (e.which === 13) {
				this.PopulateTable();
			}
		});
		this.SelectRoles();
		this.SelectSubReciepents();

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{},
			(resp) => {
				const modifiedPermissions = resp.data
					.filter((p) => p.permissioN_GROUP === "Users" && p.permissioN_ALLOWED)
					.map((d) => d.permissioN_NAME);
				this.setState({ permissions: modifiedPermissions });
			}
		);
	}

	GetPageConfigData = (CallBack) => {
		this.props.ShowLoader({ Isloading: true });
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		var d4 = $.Deferred();

		this.SelectProvinces(() => {
			d2.resolve();
		});
		this.SelectDistricts(() => {
			d3.resolve();
		});
		this.SelectTehsil(() => {
			d4.resolve();
		});

		$.when(d2, d3, d4).done(() => {
			this.props.ShowLoader({ Isloading: false });
			CallBack();
		});
	};

	SelectRoles = () => {
		this.setState({ RolesLoader: true });

		var Parameters = {
			pageSize: this.state.sizePerPage,
			pageNumber: this.state.page,
		};

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_Role,
			Parameters,
			(resp) => {
				this.setState({
					Roleslist: resp.data,
					RolesLoader: false,
				});
			},
			() => {
				this.setState({ RolesLoader: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{},
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDistricts = (Callback) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(data) => {
				this.setState({
					DistrictLoader: false,
					Districtlist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectTehsil = (Callback) => {
		this.setState({ TehsilLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Tehsil,
			{},
			(data) => {
				this.setState({
					TehsilLoader: false,
					Tehsillist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ TehsilLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};

	handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
		if (type === "sort") {
			let tempFieldorderLabel = sortField + "sortOrder";
			let tempFieldorder =
				this.state[tempFieldorderLabel] === ""
					? sortOrder
					: this.state[tempFieldorderLabel] === "asc"
					? "desc"
					: "asc";
			this.setState(
				{
					sortField,
					[tempFieldorderLabel]: tempFieldorder,
				},
				() => {
					this.PopulateTable();
				}
			);
			return;
		}
		this.setState(
			{
				page,
				sizePerPage,
			},
			() => {
				this.PopulateTable();
			}
		);
	};

	ExportPdf = () => {
		const doc = new jsPDF();
		this.setState({ loadingExport: true });

		this.setState(
			(prevState) => ({
				Parameters: {
					...prevState.Parameters,
					pageSize: this.state.TotalRecord,
				},
			}),
			() => {
				Common.Ajax(
					this.props.UserAuthentication.AuthToken,
					"Get",
					false,
					Common.APILinks.SelectAll_Users,
					this.state.Parameters,
					(resp) => {
						$("#FormSearchBtn").prop("disabled", false);
						this.setState({ loading: false });
						if (resp.status) {
							doc.autoTable({
								theme: "grid",
								body: [...resp.data],
								columns: [
									{ header: "id", dataKey: "id" },
									{ header: "Name", dataKey: "name" },
									{ header: "Contact", dataKey: "contact" },
									{ header: "Account #", dataKey: "accountNumber" },
									{ header: "SR Name", dataKey: "short_name" },
									{ header: "Role", dataKey: "roleName" },
									{ header: "RiderType", datakey: "ridertype" },
									{ header: "Active", dataKey: "isActive" },
									{ header: "Province", dataKey: "provinceName" },
									{ header: "Tehsil", dataKey: "tehsilName" },
									{ header: "District", dataKey: "districtName" },
								],
							});

							doc.save("users.pdf");
							this.setState({ loadingExport: false });
						}
					}
				);
			}
		);
	};

	ExportData = () => {
		this.setState(
			(prevState) => ({
				Parameters: {
					...prevState.Parameters,
					pageSize: this.state.TotalRecord,
				},
				exportLoading: true,
			}),
			() => {
				Common.Ajax(
					this.props.UserAuthentication.AuthToken,
					"Get",
					false,
					Common.APILinks.SelectAll_Users,
					this.state.Parameters,
					(resp) => {
						$("#FormSearchBtn").prop("disabled", false);
						this.setState({ loading: false });
						if (resp.status) {
							this.setState({
								data: resp.data,
								exportLoading: false,
							});
							$(".react-bs-table-csv-btn").click();
							setTimeout(() => {
								this.PopulateTable();
							}, 500);
						}
					}
				);
			}
		);
	};

	SelectSubReciepents = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectALl_SubRecipient,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						SrList: resp.data.map((d) => ({
							id: d.id,
							name: d.short_name,
							...d,
						})),
					});
				}
			}
		);
	};

	PopulateTable = () => {
		$("#FormSearchBtn").prop("disabled", true);
		this.setState({ loading: true, data: [], TotalRecord: 0 });
		var provinceIdString =
			this.state.ProvinceId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
		var districtIdString =
			this.state.DistrictId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
		var tehsilIdString =
			this.state.TehsilId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
		var subrecipientIdString =
			this.state.SrId.length === 0
				? ""
				: "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

		const Parameters = {
			provinceId: provinceIdString,
			districtId: districtIdString,
			tehsilId: tehsilIdString,
			UserName: $("#SearchName").val(),
			FilingStatus: $("#filingStatus").val(),
			UserPhone: $("#UserPhone").val(),
			RoleId: this.state.RoleId,
			pageSize: this.state.sizePerPage,
			pageNumber: this.state.page,
			srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
			sortField: this.state.sortField,
			srids: subrecipientIdString,
			riderType: this.state.riderType,
			sortOrder: this.state[this.state.sortField + "sortOrder"],
		};

		this.setState({ Parameters });

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_Users,
			Parameters,
			(resp) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				if (resp.status) {
					console.log({ a: resp.data });
					// if(resp.data.length > 0)
					// {
					//     var ProcessedRoles= Common.ProcessDataInArray(this.state.Roleslist,"id")
					//     var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
					//     var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
					//     var ProcessedTehsil= Common.ProcessDataInArray(this.state.Tehsillist,"id")
					//     for (var i in resp.data)
					//     {
					//         resp.data[i].roleName = ProcessedRoles[resp.data[i].role].roleName
					//         resp.data[i].provinceName = ProcessedProvince[resp.data[i].addressProvinceId]?.name
					//         resp.data[i].districtName = ProcessedDistrict[resp.data[i].addressDistrictId]?.name
					//         resp.data[i].tehsilName = ProcessedTehsil[resp.data[i].addressTehsilId]?.name
					//     }
					// }
					this.setState({
						data: resp.data,
						TotalRecord: resp.totalRecord,
					});
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(_error) => {
				$("#FormSearchBtn").prop("disabled", false);
				this.setState({ loading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	onDelete = (id, roleId) => {
		this.setState(
			{
				alertModalData: {
					title: "Delete User",
					message: "Are you sure you want to delete this record.",
					First_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
						this.DeleteRecord(id, roleId);
					},
					Second_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
					},
					type: 1,
				},
			},
			() => {
				$("#Show_ArletModal").click();
			}
		);
	};

	DeleteRecord = (id, roleId) => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Delete_User,
			{
				id: id,
				roleId: roleId,
			},
			(Result) => {
				if (Result.status) {
					if (roleId === 4) {
						SyncConfig(
							() => {
								this.PopulateTable();
								this.props.ShowLoader({ Isloading: false });
								this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
								setTimeout(function () {
									$("#Alertmsgbtn").click();
								}, 50);
							},
							() => {
								this.props.ShowLoader({ Isloading: false });
								this.props.ShowAlert({
									Type: 0,
									Msg: "Error in sync, please reload the page",
								});
								setTimeout(function () {
									$("#Alertmsgbtn").click();
								}, 50);
							}
						);
					} else {
						this.props.ShowLoader({ Isloading: false });
						this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully" });
						setTimeout(function () {
							$("#Alertmsgbtn").click();
						}, 50);
						this.PopulateTable();
					}
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(_error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wronge, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	closePdfModal = () => {
		this.setState({
			downloadPdfOthers: false,
			downloadPdfRiders: false,
			pdfData: {},
		});
	};

	handleDownloadPdf = (row) => {
		this.setState({
			downloadPdfOthers: row.role !== 4,
			downloadPdfRiders: row.role === 4,
			pdfData: _.pick(row, [
				"agreementDate",
				"facilityName",
				"short_name",
				"name",
			]),
		});
	};

	render() {
		const CellMenu = (_cell, row) => {
			return (
				<div>
					<Link
						hidden={!this.state.permissions.includes("users-update")}
						to={"/User_Edit/" + row.id}
					>
						<button data-toggle="tooltip" title="Edit" className="btn TableRow_btn">
							<i
								className="fa fa-pencil-square-o text-primary"
								aria-hidden="true"
							></i>
						</button>
					</Link>
					<button
						hidden={!this.state.permissions.includes("users-delete")}
						onClick={() => this.onDelete(row.id, row.role)}
						data-toggle="tooltip"
						title="Delete"
						className="btn text-red TableRow_btn"
					>
						<i className="fa fa-trash-o text-danger" aria-hidden="true"></i>
					</button>
				</div>
			);
		};
		//users-update
		// function avatarformatter(cell, row) {
		//     return (
		//         <span style={{ display: "flex" }}>
		//             <span style={{ flex: "1", maxWidth: "45px", minWidth: "45px", position: "relative", bottom: "-5px" }}>
		//                 <img className="user-avatar rounded-circle" style={{ border: "1px solid #ced4da" }} height="37px" width="37px" src={row.imageURLBase64 == "" || row.imageURLBase64 == null ? UserLogo_Tablelist : row.imageURLBase64} />
		//             </span>
		//             <span>
		//                 {row.name}<br />
		//                 <span>{row.contact}</span>
		//             </span>

		//         </span>
		//     );
		// }

		const UserTypeformatter = (cell, _row) => {
			return <div className="UserType_Span">{cell}</div>;
		};

		const columns = [
			{
				dataField: "id",
				text: "Id",
				export: true,
				headerStyle: (_colum, _colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			{
				dataField: "provinceName",
				text: "Province",
				sort: true,
				headerStyle: (_colum, _colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			{
				dataField: "short_name",
				text: "Sr. Name",
				headerStyle: () => {
					return { fontSize: "13px", width: "100px" };
				},
				sort: true,
			},
			{
				dataField: "districtName",
				text: "District",
				sort: true,
				headerStyle: (_colum, _colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			{
				dataField: "tehsilName",
				text: "Tehsil",
				sort: true,
				headerStyle: (_colum, _colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},

			{
				dataField: "name",
				text: "User Name",
				// formatter: (cell, row) => { return avatarformatter(cell, row) },
				headerStyle: (_colum, _colIndex) => {
					return { width: "145px", fontSize: "13px" };
				},
			},
			{
				dataField: "accountNumber",
				text: "Account Number",
				// formatter: (cell, row) => { return avatarformatter(cell, row) },
				headerStyle: (_colum, _colIndex) => {
					return { width: "145px", fontSize: "13px" };
				},
				csvExport: true,
			},
			{
				dataField: "contact",
				text: "Contact",
				// formatter: (cell, row) => { return avatarformatter(cell, row) },
				headerStyle: (_colum, _colIndex) => {
					return { width: "145px", fontSize: "13px" };
				},
			},
      {
				dataField: "cnic",
				text: "CNIC",
				headerStyle: (_colum, _colIndex) => {
					return { width: "145px", fontSize: "13px" };
				},
			},

			{
				dataField: "facilityName",
				text: "Facility",
				sort: true,
				headerStyle: (_colum, _colIndex) => {
					return { width: "100px", fontSize: "13px" };
				},
			},
			{
				dataField: "clusterName",
				text: "Cluster",
				sort: true,
				headerStyle: (_colum, _colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
			},
			// {
			//     dataField: 'contact',
			//     text: 'Phone',
			//     sort: true,
			//     csvFormatter:contact => ( contact==null?"":contact ),
			// },
			{
				dataField: "roleName",
				text: "User Type",
				formatter: (cell, row) => {
					return UserTypeformatter(cell, row);
				},
				headerStyle: (_colum, _colIndex) => {
					return { width: "160px", fontSize: "13px" };
				},
				sort: true,
			},
			{
				dataField: "ridertype",
				text: "Rider Type",
				headerStyle: (_colum, _colIndex) => {
					return { width: "220px" };
				},
				sort: true,
			},
			{
				dataField: "isActive",
				text: "Status",
				headerStyle: (_colum, _colIndex) => {
					return { width: "70px", fontSize: "13px" };
				},
				formatter: (cell, _row) => {
					return <span>{cell ? "Active" : "InActive"}</span>;
				},
				csvFormatter: (isActive) => (isActive ? "Active" : "InActive"),
			},
			{
				dataField: "filingStatus",
				text: "Filing Status",
				headerStyle: (_colum, _colIndex) => {
					return { width: "70px", fontSize: "13px" };
				},
				formatter: (cell, _row) => {
					return <span>{cell ? "Filer" : "Non Filer"}</span>;
				},
				csvFormatter: (isActive) => (isActive ? "Filer" : "Non Filer"),
			},
			{
				dataField: "appVersion",
				text: "App Version",
				headerStyle: (_colum, _colIndex) => {
					return { width: "110px", fontSize: "13px" };
				},
				// sort: true,
			},
			{
				dataField: "",
				text: "Actions",
				headerStyle: (_colum, _colIndex) => {
					return { width: "100px", fontSize: "13px" };
				},
				formatter: (cell, row) => {
					return CellMenu(cell, row);
				},
				csvExport: false,
			},
			{
				dataField: "",
				text: "Agreements",
				headerStyle: (_colum, _colIndex) => {
					return { width: "100px", fontSize: "13px" };
				},
				formatter: (cell, row) => {
					return (

						 row.isAgreement == true ?
						<button
							data-toggle="tooltip"
							title="Download PDF"
							className="btn TableRow_btn"
							onClick={() => this.handleDownloadPdf(row)}
						>
							<i className="fa fa-file-pdf-o text-primary" aria-hidden="true"></i>
						</button> : null
					);
				},
				csvExport: false,
			},

			{
				dataField: "isAgreement",
				text: "Agreement",
				headerStyle: (_colum, _colIndex) => {
					return { width: "100px", fontSize: "13px" };
				},
				hidden:true,
				csvExport:true,
			},


			{
				dataField: "agreementDate",
				text: "Agreement Date",
				
				headerStyle: (colum, colIndex) => {
					return { width: "115px", fontSize: "13px" };
				},
				formatter: (cell, row) => {
					
					return row.isAgreement == true ?
					Common.ConvertToLocalDateTime(cell) : null
				},
				csvFormatter: (agreementDate) =>
					Common.ConvertToLocalDateTime(agreementDate),
				sort: true,
			},
		];

		return (
			<div>
				<MainLayout />
				<AlertModal {...this.state.alertModalData} />
				<div id="right-panel" className="right-panel">
					{/* this.state.permissions.includes('users-add') */}
					<Topmenu
						PageTitle="Users & Requests"
						isShowAddBtn={this.state.permissions.includes("users-add")}
						AddBtnLabel="Add User"
						AddBtnLink="/User_Add"
					/>
					<div className="content">
						{/* <div className="PageHeader_Container">
                                <h2 className="Pageheading">Users</h2>
                                <div className="PageMenu_Container"><Link to="/User_Add"><button className="btn btn_style2">Add User</button></Link></div>
                            </div> */}

						<div
							className="card"
							style={{
								marginBottom: "20px",
								background: "none",
								boxShadow: "none",
							}}
						>
							<div className="card-body row" style={{ padding: "0px" }}>
								<div className="widget-tabs-list">
									<ul className="Cases-nav nav nav-tabs">
										<li>
											<Link to="/Users" className="active show">
												Users
											</Link>
										</li>
										<li>
											<Link to="/User_Requests">
												Requests
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>

						<div className="card">
							<div className="card-body">
								<div className="Table_Search row">
									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Province</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="ProvinceId"
											options={this.state.Provincelist}
											val={this.state.ProvinceId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.ProvinceLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Sub Recipient</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="SrId"
											options={this.state.FilteredSrs}
											val={this.state.SrId}
											addPlaceholder=""
											disabled={false}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">District</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="DistrictId"
											options={this.state.FilteredDistrictlist}
											val={this.state.DistrictId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.DistrictLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Tehsil</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="TehsilId"
											options={this.state.FilteredTehsillist}
											val={this.state.TehsilId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.TehsilLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">User Type</label>
										<DropDown
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="RoleId"
											options={this.state.Roleslist}
											val={this.state.RoleId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.RolesLoader}
											searchBy="roleName"
											labelField="roleName"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label>Filing Status</label>
										<select id="filingStatus" className="form-control">
											<option value="">--Select--</option>
											<option value="0">Non Filer</option>
											<option value="1">Filer</option>
										</select>
									</div>

									<div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">Rider Type</label>
										<DropDown
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleRiderTypeValChange}
											Type="riderType"
											options={this.RiderTypes}
											addPlaceholder=""
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">User Name</label>
										<input
											autoComplete="off"
											type="text"
											className="form-control Search_InputField"
											id="SearchName"
											placeholder="Enter user name"
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">User Phone</label>
										<input
											autoComplete="off"
											pattern="[0][0-9]{10}"
											type="number"
											className="form-control Search_InputField"
											id="UserPhone"
											placeholder="Enter user phone"
										/>
									</div>

									<div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<button
											onClick={() => {
												this.PopulateTable();
											}}
											style={{ position: "relative", marginTop: 36 }}
											id="FormSearchBtn"
											className="btn SearchTable_Btn"
										>
											Search
										</button>
									</div>
								</div>

								{/* <div className="TableTop_Buttons">
                        <span onClick={() => { $(".react-bs-table-csv-btn").click()}} className="TableExport_button"><i className="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

								<OthersPDF
									visible={this.state.downloadPdfOthers}
									closePdfModal={this.closePdfModal}
									pdfData={this.state.pdfData}
								/>

								<RidersPDF
									visible={this.state.downloadPdfRiders}
									closePdfModal={this.closePdfModal}
									pdfData={this.state.pdfData}
								/>

								<Table
									keyField="id"
									data={this.state.data}
									page={this.state.page}
									sizePerPage={this.state.sizePerPage}
									exportPdf={this.ExportPdf}
									changeSizePerPage={() => this.ExportData()}
									exportAllowed={this.state.permissions.includes(
										"users-export"
									)}
									totalSize={this.state.TotalRecord}
									exportLoading={this.state.exportLoading}
									onTableChange={this.handleTableChange}
									isPagination={true}
									columns={columns}
									pdfExportLoading={this.state.loadingExport}
									loading={this.state.loading}
									RefreshTable={this.PopulateTable}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Users_List);
